function Loader() {
  return (
    <div className="fa-3x loader">
      <i className="fa-solid fa-cog fa-spin fa-spin-reverse"></i> Loading...
    </div>
  );
}

export default Loader;
